import script from "./FocusModeNoteModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./FocusModeNoteModal.vue?vue&type=script&setup=true&lang=ts"

import "./FocusModeNoteModal.vue?vue&type=style&index=0&id=dccff48a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dccff48a"]])

export default __exports__